
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}.heading{margin-top:1rem}.description{font-family:var(--ff-body);margin-top:1.25rem}.description img{border-radius:var(--br-min)}.description p{margin:var(--spacing-0)}.with-border{border-radius:var(--br-min);outline:1px solid var(--black-200);padding:var(--spacing-6)}.card-border{background-color:var(--white);border:1px solid var(--black-450);border-radius:var(--br-min);height:100%;padding:var(--spacing-6)}.cta{display:flex;justify-content:center;margin-top:1rem}.align-icon-text{align-items:center;-moz-column-gap:var(--gap-base);column-gap:var(--gap-base);display:flex}`;